import { types } from 'mobx-state-tree';


const RequestMetadata = types.model('RequestMetadata', {
    userAgent: types.maybe(types.string),
    referrer: types.maybe(types.string),
    ip: types.maybe(types.string),
    gacid: types.maybe(types.string),
    heapIdentity: types.maybe(types.string),
    visitorId: types.maybe(types.string),
});

export default RequestMetadata;
